// Development-only logger; silent in production builds.
const enabled = process.env.NODE_ENV !== "production";
export const log = {
  warn: (...a) => enabled && console.warn(...a),
  error: (...a) => enabled && console.error(...a),
};
